// extracted by css-extract-rspack-plugin
export default {"connector":"connector-RlGn_F","arrowhead":"arrowhead-kujvqZ"};